module.exports = __webpack_public_path__ + "img/TraumV.5cd8d05d.jpg";